import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { useAuth } from 'auth/hooks';
import { getIntlPath } from 'common/utils';

export const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
    const { isLoggedIn } = useAuth();

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isLoggedIn() ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: getIntlPath('login'),
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};
